module.exports = __webpack_public_path__ + "img/2-3.bd64b43e.svg";